
import Vue from 'vue'
import CloseButton from './buttons/CloseButton.vue'
import { mapState } from 'vuex'
import { URLParameterRange_ActivityType, ProjectState } from '../channel.types'

export default Vue.extend({
  props: ['src'],
  data() {
    return {
      _iFrameLoaded: false,
      _iFrameAppIsReadyForInteraction: false,
    }
  },
  computed: mapState({
    selection: state => (<ProjectState>state).selection,
  }),
  methods: {
    close() {
      const activityId = this.selection.activity.id
      const rowId = this.selection.row.id
      const channelSlug = this.$route.params.channelSlug
      const secondScreenEnabled = this.selection.row.is_enabled_second_screen
      const articleType = this.selection.row.is_enabled_article_format
        ? URLParameterRange_ActivityType.ARTICLE
        : URLParameterRange_ActivityType.ACTIVITY

      //When a hero-carousel activity gets closed, the path just reverts back to something like /c/network-comparison
      //and this is because hero-carousel really has no "expanded" state. Other activities whether articles or otherwise
      //have an expanded state where we want the url to explicitly point to their expanded-states.
      //
      //Also, when an activity with no second-screen (article or expanded) gets closed, then we also want to just go right
      //back to the channel and not back to the second-screen.
      const path =
        this.selection.row.type == 'HERO_CAROUSEL' || !secondScreenEnabled
          ? `/c/${channelSlug}`
          : `/c/${channelSlug}/${rowId}/${articleType}/${activityId}`

      this.$router.push({ path })
    },

    onMessage({ data }) {
      if (data === 'ACTIVITY_FINISHED') {
        this.close()
      }
    },
    iFrameLoaded() {
      this._iFrameLoaded = true
    },
    activityAppReadyPromise() {
      return new Promise((resolve, reject) => {
        let iteration = 0
        let t = setInterval(() => {
          if (
            this.$refs.activity_iframe &&
            this.$refs.activity_iframe.contentWindow.isActivityAppReady
          ) {
            clearInterval(t)
            resolve()
          }
          iteration++
          if (iteration > 100) {
            clearInterval(t)
            reject()
          }
        }, 100)
        return t
      })
    },
    iFramePromise() {
      return new Promise((resolve, reject) => {
        let iteration = 0
        let t = setInterval(() => {
          if (this._iFrameLoaded) {
            clearInterval(t)
            resolve()
          }
          iteration++
          if (iteration > 100) {
            clearInterval(t)
            reject()
          }
        }, 100)
        return t
      })
    },

    // sleepPromise(ms) {
    //   return new Promise(resolve => {
    //     return setTimeout(resolve, ms)
    //   })
    // },
    //////////////////
  },
  components: {
    CloseButton,
  },
  created() {
    window.addEventListener('message', this.onMessage)
  },
  destroyed() {
    this.$store.dispatch('fetch_viewer_data')
    window.removeEventListener('message', this.onMessage)
  },
  async mounted() {
    await Promise.all([this.iFramePromise(), this.activityAppReadyPromise()])

    this._iFrameAppIsReadyForInteraction = true

    this.$refs.activity_iframe.contentWindow.channelApp.addEventListener(
      'log',
      value => {
        console.log.apply(null, value)
      }
    )

    this.$refs.activity_iframe.contentWindow.consoleToParentWindow.addEventListener(
      'activity_action',
      value => {
        console.log('caught an action from the embedded activity!')
        this.$store.commit('incrementActivityActions')
      }
    )

    //Set the window of the embedded iframe. We need to communicate with that application periodically.
    window.setEmbeddedActivityWindow(this.$refs.activity_iframe.contentWindow)
  },
})
